import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { NotaFiscalSintetica } from '../../models/notas-fiscais/nota-fiscal-sintetica';

@Injectable({
  providedIn: 'root'
})

export class NotaFiscalService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  /* Sintética */

  public getNotaFiscalSinteticaByCNPJ(cnpj: string): Observable<NotaFiscalSintetica[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "cnpj": cnpj,
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<NotaFiscalSintetica[]>(this.baseUrl + "api/NotaFiscal/GetNotaFiscalSinteticaByCNPJ", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }
}
